<template>
  <div class="page">
    <klfs-header tab="news"></klfs-header>

    <div class="page-wrapper">

      <div class="section-block index-bg-img">
        <img src="../../assets/news/banner2.jpg" alt="">
      </div>

      <div class="section-block">
        <div class="section-block-wrap xf-wrapper">
          <h1 class="section-title">品牌IP</h1>
          <div class="xf-content flex-center">
            <div class="xf-img">
              <img src="../../assets/news/xf.png" alt="">
            </div>
            <div class="xf-dhxf">
              <div>
                <img src="../../assets/news/dhxf.png" alt="">
              </div>
              <div class="xf-two-view">
                <img src="../../assets/news/xf-2.png" alt="">
              </div>
              <p class="xg-text">性格：乐观治愈，传递品牌精神</p>
            </div>
            <div class="xf-birthday-view">
              <div class="xf-birthday-date">生日：2008年4月18日</div>
              <div class="xf-five-view">
                <img src="../../assets/news/xf-5.png" alt="">
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="section-block co-branded-section">
        <div class="section-block-wrap">
          <h1 class="section-title">联名营销</h1>
          <div class="co-branded-content">
            <div class="co-list flex flex-wrap flex-just-center">
              <div class="co-item flex-center" v-for="(item, index) in coList" :key="index">
                <img :src="item.img" alt="">
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="section-block honor-section">
        <div class="section-block-wrap">
          <h1 class="section-title">品牌荣誉</h1>
          <div class="honor-content">
            <div class="honor-img">
              <img class="image" src="../../assets/news/honor.png" alt="">
            </div>
            <div class="honor-list">
              <div class="honor-tabs-view flex-center-between">
                <div class="honor-tab" :class="honorIndex == index? 'active' : ''" v-for="(item, index) in honorList" :key="item.year" @click="tapHonorTab(index)">
                  <span>{{ item.year }}</span>
                </div>
              </div>
              <div class="swiper-container swiper-honor" ref="swiperHonor">
                <div class="swiper-wrapper">
                  <div class="swiper-slide" v-for="(item, index) in honorList" :key="index">
                    <div class="honor-text-inner flex-just-center">
                      <div>
                        <span class="honor-year-tag flex">{{ item.year }}</span>
                      </div>
                      <div class="honor-text-list">
                        <div class="honor-text-item" v-for="(subItem, subIndex) in item.textList" :key="subIndex">{{subItem}}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="section-block news-section">
        <div class="section-block-wrap">
          <h1 class="section-title">品牌新闻</h1>
          <div class="news-content">
            <div class="news-big flex-align-center" v-for="(item, index) in newsListBig" :key="index">
              <a :href="'./article'+ item.id +'.html'" :title="item.title" class="news-big-img">
                <img :src="item.showImg" :alt="item.title">
              </a>
              <div class="news-big-inner">
                <div class="news-date">{{ item.showDate }}</div>
                <h3 class="news-title">{{ item.title }}</h3>
                <p class="news-text">{{ item.des }}</p>
                <a :href="'./article'+ item.id +'.html'" :title="item.title" class="news-btn">查看详情</a>
              </div>
            </div>
            <div class="news-list flex-between">
              <div class="news-item" v-for="(item, index) in newsList" :key="index">
                <a :href="'./article'+ item.id +'.html'" :title="item.title" class="news-img">
                  <img :src="item.showImg" :alt="item.title">
                </a>
                <div class="news-big-inner">
                  <div class="news-date">{{ item.showDate }}</div>
                  <a :href="'./article'+ item.id +'.html'" :title="item.title">
                    <h3 class="news-title">{{ item.title }}</h3>
                    <p class="news-text">{{ item.des }}</p>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>

    <klfs-footer></klfs-footer>
  </div>
</template>

<script>

import Swiper from 'swiper'
import KlfsHeader from "@/components/KlfsHeader.vue";
import KlfsFooter from "@/components/KlfsFooter.vue";
import host from "@/common/config";

export default {
  name: 'NewsPage',
  components: {
    KlfsHeader,
    KlfsFooter
  },
  data() {
    return {
      coList: [
        { img: require('@/assets/news/1.png') },
        { img: require('@/assets/news/2.png') },
        { img: require('@/assets/news/3.png') },
        { img: require('@/assets/news/4.png') },
        { img: require('@/assets/news/5.png') },
        { img: require('@/assets/news/6.png') },
        { img: require('@/assets/news/7.png') },
        { img: require('@/assets/news/8.png') },
        { img: require('@/assets/news/9.png') },
        { img: require('@/assets/news/10.png') },
      ],
      honorList: [
        { year: '2018', textList: ['广州餐饮连锁加盟及餐饮空间展览会“十大人气连锁品牌”'] },
        { year: '2020', textList: ['1.快乐番薯获中国品牌节金谱奖', '2.快乐番薯进入中国餐饮加盟榜TOP100'] },
        { year: '2021',
          textList: [
            '1.建发厦门马拉松赛事支持商暨指定茶饮连锁品牌',
            '2.红餐网“中国餐饮最具商业价值品牌”',
            '3.品牌网-奶茶行业十佳品牌',
            '4.关键品牌联合视频展播及热销品销售获吉尼斯世界记录',
            '5.中国品牌影响力（奶茶行业）十大消费满意品牌',
            '6.福建省连锁经营协会《烤番薯》团体标准发布（我司是第一编写单位）',
            '7.阿里巴巴本地生活最佳新锐品牌']
        },
        { year: '2024',
          textList: [
            '1、AAA知名商标品牌-快乐番薯（注册号72836293）',
            '2、2024亚洲最具投资价值品牌TOP100',
            '3、红餐网2024年度特色茶饮十大品牌',
            '4、红餐网2024年度餐饮商业价值品牌',
            '5、福建省连锁经营协会-特许品牌标杆企业',
            '6、福建省连锁经营协会-自有品牌创新企业',
          ]
        },
        { year: '2025', textList: [
            '1、2025中国餐饮加盟品牌TOP100',
            '2、2025中国餐饮新茶饮出海品牌TOP40',
            '3、2025金翼大赛实效营销赛道三等奖',
            '4、中国烹饪协会-2024年度中国餐饮企业TOP100',
            '5、超级产品榜-超多料奶茶吨吨桶（咖门&美团）',
            '6、第二届福建品牌价值评价百强称号',
            '7、2024-2025年度餐饮年度创新奖',
            '8、2025中华餐饮创新榜',
            '9、行业灯塔奖',
          ]
        },
      ],
      honorIndex: 0,
      honorSwiper: null,
      newPostData: {
        size: 4,
        page: 1,
        type: 11
      },
      newsListBig: [],
      newsList: []
    }
  },
  created() {
    this.getNews()
  },
  mounted() {
    this.initHonorSwiper()
  },
  methods: {
    getNews() {
      this.$util.fetchData(host.mainUrl + '/api/statistics/getTemplates', this.newPostData).then(res => {
        console.log(res)
        if(res.status == 200) {
          for(let item of res.payload.data) {
            item.showDate = this.$util.getDateHandle(item.created_date)
            item.showImg = this.$util.picUrlTrans(item.pic, host.imgUrl)
          }
          this.newsListBig = res.payload.data.slice(0, 1)
          this.newsList = res.payload.data.slice(1, 4)
        } else {
          console.log(JSON.stringify(res))
        }
      })
    },
    tapHonorTab(index) {
      console.log(index)
      this.honorIndex = index
      this.honorSwiper.slideTo(index)
    },
    initHonorSwiper() {
      // 人气爆品
      this.honorSwiper = new Swiper('.swiper-honor', {
        autoplay: {
          delay: 4000, //3秒切换一次
          stopOnLastSlide: false, // 当切换到最后一个slide时停止自动切换
          disableOnInteraction: false, // 用户操作swiper之后，是否禁止autoplay
        },
        loop: false,
        observer: true, //修改swiper自己或子元素时，自动初始化swiper
        observeParents: true, //修改swiper的父元素时，自动初始化swiper
        on: {
          init: () => {
            console.log('init detailSwiper')
          },
          slideChangeTransitionEnd: () => {
            this.honorIndex = this.honorSwiper.activeIndex
          },
        }
      });
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.index-bg-img img {
  display: block;
  width: 100%;
}
.section-title {
  font-size: 50px;
  color: var(--p);
  text-align: center;
  padding: 30px 0;
}

.section-block-wrap {
  max-width: 1420px;
  padding: 0 20px 100px;
  margin: 0 auto;
  position: relative;
}

.xf-wrapper {
  padding-top: 40px;
  padding-bottom: 100px;
}
.xf-content {
  background-image: url("../../assets/news/xiaofan.png");
  background-repeat: no-repeat;
  background-position: top center;
  position: relative;
  padding-bottom: 30px;
}
.xf-img {
  position: relative;
  margin-top: 130px;
  z-index: 3;
  margin-left: 110px;
}
.xf-dhxf {
  position: absolute;
  left: 0;
  bottom: 0;
}
.xf-two-view {
  margin-top: 40px;
  margin-bottom: 40px;
}
.xg-text {
  font-size: 34px;
  font-weight: bold;
  color: var(--p);
}

.xf-birthday-view {
  position: absolute;
  right: 0;
  bottom: 0;
}
.xf-birthday-date {
  line-height: 1;
  font-size: 34px;
  font-weight: bold;
  color: var(--p);
  padding: 20px 30px;
  background-color: #fff8b0;
  border-radius: 8px;
  margin-bottom: 24px;
}

.co-branded-section {
  background-color: var(--o);
}
.co-branded-section .section-title {
  color: #fff;
  padding: 50px 0;
}
.co-item {
  width: 20%;
  padding: 0 12px;
  margin-bottom: 24px;
}
.co-item img {
  transition: all 0.3s;
}
.co-item img:hover {
  transform: scale(1.1);
}

.honor-section {
  background-color: #f8f8f8;
}
.honor-tabs-view {
  border-bottom: 1px dashed var(--o);
}
.honor-tab {
  font-family: "bold";
  line-height: 1;
  font-weight: bold;
  font-size: 45px;
  color: var(--p);
  position: relative;
  padding-bottom: 30px;
  cursor: pointer;
}
.honor-tab span {
  opacity: 0.5;
}
.honor-tab:after {
  content: ' ';
  display: block;
  width: 14px;
  height: 14px;
  background-color: #f8f8f8;
  border: 2px solid var(--p);
  border-radius: 50%;
  position: absolute;
  left: 50%;
  bottom: -9px;
  margin-left: -9px;
}
.honor-tab.active span {
  opacity: 1;
}
.honor-tab.active:after {
  background-color: var(--p);
}

.honor-text-inner {
  padding-top: 85px;
}
.honor-year-tag {
  font-family: "bold";
  color: #fff;
  font-size: 20px;
  background-color: var(--p);
  margin-right: 38px;
  border-radius: 100%;
  padding: 2px 10px;
}
.honor-text-list {
  font-size: 20px;
  line-height: 35px;
}
.honor-img {
  margin-bottom: 30px;
}

.news-section {
  padding-top: 40px;
}
.news-content {
  padding-top: 20px;
}
.news-big {
  margin-bottom: 50px;
}
.news-big-inner {
  flex: 1;
}
.news-big-img {
  display: block;
  width: 50%;
  height: 300px;
  background-color: var(--o);
  border-radius: 30px;
  margin-right: 30px;
  overflow: hidden;
}
.news-item {
  width: 32%;
}
.news-img {
  display: block;
  height: 240px;
  background-color: var(--o);
  border-radius: 20px;
  margin-bottom: 20px;
  overflow: hidden;
}
.news-img img,
.news-big-img img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: all .5s;
}
.news-date,
.news-text {
  font-size: 18px;
  color: var(--g2);
}
.news-text {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box; /* 启用弹性盒子布局 */
  -webkit-line-clamp: 2; /* 这个属性只在webkit内核的浏览器中有效 */
  -webkit-box-orient: vertical; /* 设置盒子方向为垂直方向 */
}
.news-title {
  font-weight: normal;
  line-height: 1;
  font-size: 30px;
  margin: 10px 0;
  transition: all .5s;
}
.news-big .news-title {
  margin: 30px 0 20px;
}
.news-btn {
  display: block;
  width: 158px;
  height: 46px;
  line-height: 46px;
  font-size: 18px;
  text-align: center;
  color: var(--o);
  border: 1px solid var(--o);
  border-radius: 46px;
  margin-top: 20px;
  transition: all .5s;
}
.news-btn:hover {
  color: #fff;
  background-color: var(--o);
}
.news-item:hover .news-title {
  color: var(--o);
}
.news-big:hover img,
.news-item:hover img {
  transform: scale(1.1);
}

@media screen and (max-width: 1400px) {
  .xf-wrapper {
    padding-bottom: 80px;
  }
  .xf-content {
    background-size: 100%;
  }
  .xf-img {
    width: 400px;
    margin-top: 30px;
  }
  .xf-content img {
    display: block;
    width: 100%;
  }
  .xf-dhxf {
    width: 240px;
    bottom: -40px;
  }
  .xf-two-view {
    width: 240px;
  }
  .xg-text {
    font-size: 16px;
  }
  .xf-birthday-view {
    bottom: -40px;
  }
  .xf-birthday-date {
    font-size: 18px;
    padding: 10px;
    margin-bottom: 5px;
  }
  .xf-five-view {
    width: 240px;
  }
  .co-item {
    padding: 0 6px;
  }
  .co-item img {
    display: block;
    width: 100%;
  }
}

@media screen and (max-width: 768px) {
  .section-title {
    font-size: 22px;
    padding: 20px 0;
  }
  .section-block-wrap {
    padding: 0 15px 40px;
  }
  .xf-wrapper {
    padding-bottom: 80px;
  }
  .xf-content {
    background-size: 100%;
  }
  .xf-img {
    width: 200px;
    margin-top: 30px;
  }
  .xf-content img {
    display: block;
    width: 100%;
  }
  .xf-dhxf {
    width: 120px;
    bottom: -40px;
  }
  .xf-two-view {
    width: 120px;
  }
  .xg-text {
    font-size: 14px;
  }
  .xf-birthday-view {
    bottom: -40px;
  }
  .xf-birthday-date {
    font-size: 12px;
    padding: 10px;
    margin-bottom: 5px;
  }
  .xf-five-view {
    width: 150px;
  }

  .co-branded-section .section-title {
    padding: 30px 0;
  }
  .co-item {
    width: 50%;
    padding: 0 5px;
    margin-bottom: 10px;
  }
  .co-item img {
    display: block;
    width: 100%;
  }

  .honor-section .section-block-wrap {
    padding-bottom: 20px;
  }
  .honor-tab {
    font-size: 18px;
  }
  .honor-img {
    margin-bottom: 20px;
  }
  .honor-text-list {
    font-size: 12px;
    line-height: 24px;
  }
  .honor-year-tag {
    font-size: 16px;
    margin-right: 10px;
  }
  .honor-text-inner {
    padding-top: 40px;
  }

  .news-section {
    padding-top: 0;
  }
  .news-content {
    padding-top: 0;
  }
  .news-big {
    flex-direction: column;
    margin-bottom: 20px;
  }
  .news-big-img {
    width: 100%;
    height: 180px;
    margin-right: 0;
    margin-bottom: 10px;
    border-radius: 8px;
  }
  .news-date {
    font-size: 12px;
  }
  .news-title {
    font-size: 16px;
  }
  .news-big .news-title {
    margin: 10px 0;
  }
  .news-text {
    font-size: 12px;
  }
  .news-btn {
    display: none;
  }
  .news-list {
    flex-direction: column;
  }
  .news-item {
    width: 100%;
    margin-bottom: 20px;
  }
  .news-img {
    height: 180px;
    margin-bottom: 10px;
  }
  .news-section .section-block-wrap {
    padding-bottom: 20px;
  }
}
</style>
